import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';
import { Bumpout } from '@app/models';

export interface BumpoutApi {
    items: any[];
    total_count: number;
}

@Injectable({ providedIn: 'root' })
export class BumpoutService {
    public  bumpoutsEnabled: boolean = true; // Disable if this is being worked on
    private currentBumpout;

    private API_URL = '/api/bumpouts/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(
        private httpClient: HttpClient
    ) { }

    setCurrent(_bumpout): void {
        this.currentBumpout = _bumpout;
    }


    getCurrent() {
        return this.currentBumpout;
    }


    getAll(): Observable<Bumpout[]> {
        return this.httpClient.get<Bumpout[]>(this.API_URL);
    }


    get(_id: string): Observable<Bumpout> {
        return this.httpClient.get<Bumpout>(this.API_URL + _id);
    }


    getByClient(_clientId: string): Observable<Bumpout> {
        return this.httpClient.get<Bumpout>(this.API_URL + 'byClient/' + _clientId);
    }


    getEnabledByClient(_clientId: string): Observable<Bumpout> {
        return this.httpClient.get<Bumpout>(this.API_URL + 'isEnabled/byClient/' + _clientId);
    }


    create(_bumpout): Observable<Bumpout> {
        return this.httpClient.post<Bumpout>(this.API_URL, JSON.stringify(_bumpout), this.headerOptions);
    }


    selectAllSearch(searchParams): Observable<BumpoutApi> {
        searchParams['selectAll'] = true;
        return this.httpClient.post<BumpoutApi>(this.API_URL + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField = 'createdAt', sortDirection = 'desc', pageNumber: number = 0, pageSize: number = 10): Observable<BumpoutApi> {
        searchParams['selectAll'] = false;

        searchParams.sortField = sortField;
        searchParams.sortOrder = sortDirection;
        searchParams.pageNumber = pageNumber;
        searchParams.pageSize = pageSize;

        return this.httpClient.post<BumpoutApi>(this.API_URL + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
    }


    update(_bumpout: Bumpout): Observable<Bumpout> {
        return this.httpClient.put<Bumpout>(`${this.API_URL}${_bumpout._id}`, JSON.stringify(_bumpout), this.headerOptions);
    }


    delete(_id: string): Observable<Bumpout> {
        return this.httpClient.delete<Bumpout>(this.API_URL + _id);
    }


    deleteByIdArray(arrayOfIds): Observable<any[]> {
        const deleteRequest = {ids: arrayOfIds};
        return this.httpClient.put<any>(this.API_URL + 'delete-forever/by-array', JSON.stringify(deleteRequest), this.headerOptions);
    }


    sortArrayByOrder(_arrayToSort): Promise<any[]> {
        return new Promise(async(resolve) => {
            let sortedUserDashArray = _arrayToSort.sort(this.sortByOrder);
            resolve(sortedUserDashArray);
        });
    }


    sortByOrder( a, b ) {
        if (a.options == undefined || a.options.order == undefined) return 1;
        else if (b.options == undefined || b.options.order == undefined) return -1;
        else if ( a.options.order < b.options.order ) return -1;
        else if ( a.options.order > b.options.order ) return 1;
        else return 0;
    }
}